export const toFixedWithRound = (number: number, precision = 1): number => {
    const factor = Math.pow(10, precision)
    return Math.round(number * factor) / factor
}
